const ChartOfAccounts = () => import("Core/configuration/chart_of_accounts/views/ChartOfAccounts");
const ChartOfAccountsForm = () => import("Core/configuration/chart_of_accounts/views/ChartOfAccountsForm");

export default {
    children: [
        {
            path: "configuration/chart_of_accounts",
            name: "chart_of_accounts",
            component: ChartOfAccounts,
            meta: {
                requiresAuth: true,
                title: "lang.chart_of_accounts",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["chart_of_accounts.read"],
            },
        },
        {
            path: "configuration/chart_of_account/:id?",
            name: "chart_of_account",
            component: ChartOfAccountsForm,
            meta: {
                requiresAuth: true,
                title: "lang.chart_of_accounts",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["chart_of_accounts.read"],
            },
        },
    ],
};
